import { DateTime } from 'luxon'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useStyletron } from '../../../../theme'
import capitalize from '../../../../utils/capitalize'

export interface MonthProps {
    onClick: (value: DateTime) => void
    value: DateTime
    selected: boolean
    disabled: boolean
}

const Month = ({ onClick, value, disabled, selected }: MonthProps) => {
    const [css, theme] = useStyletron()
    const { i18n } = useTranslation()

    return (
        <div
            className={css({
                width: '100%',
                cursor: !disabled ? 'pointer' : 'not-allowed',
                borderRadius: '30px',
                transition: 'all ease-in-out .2s',
                border: '1px solid transparent',
                backgroundColor: theme.colors.primary50,
                ':hover': {
                    border: '1px solid',
                    borderColor: theme.colors.primary200,
                    backgroundColor: theme.colors.primary50
                },
                ...(selected && {
                    backgroundColor: theme.colors.primary,
                    ':hover': {
                        border: '1px solid',
                        borderColor: theme.colors.primary300,
                        backgroundColor: theme.colors.primary300
                    }
                }),
                ...(disabled && {
                    backgroundColor: theme.colors.mono100,
                    ':hover': {
                        border: '1px solid',
                        borderColor: theme.colors.mono100,
                        backgroundColor: theme.colors.mono100
                    }
                })
            })}
        >
            <div
                className={css({
                    height: '100%',
                    width: '100%',
                    textAlign: 'center',
                    alignSelf: 'baseline',
                    padding: '8px 0px',
                    transition: 'all ease-in-out .2s',
                    color: theme.colors.primary,
                    ...(selected && { color: theme.colors.white }),
                    ...(disabled && { color: theme.colors.mono300 }),
                    ...(!selected &&
                        !disabled && {
                            ':hover': {
                                color: theme.colors.primary200
                            }
                        }),
                    ...theme.typography.LabelSmall
                })}
                onClick={() => !disabled && !selected && onClick(value)}
            >
                {capitalize(value.setLocale(i18n.language).toFormat('MMM').substring(0, 3))}
            </div>
        </div>
    )
}

export default Month
